import DOMPurify from 'dompurify';
import { marked } from 'marked';

marked.setOptions({ gfm: true, breaks: true });

type DOMPurifyFactory = (win: Window) => typeof DOMPurify;

function getPurify(): typeof DOMPurify {
  const factory = DOMPurify as unknown as DOMPurifyFactory & typeof DOMPurify;
  return typeof window !== 'undefined' ? factory(window) : factory;
}

function preStrip(html: string): string {
  return html
    .replace(/\s+on[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
    .replace(
      /\shref\s*=\s*("javascript:[^"]*"|'javascript:[^']*'|javascript:[^\s>]+)/gi,
      ''
    )
    .replace(
      /\ssrc\s*=\s*("javascript:[^"]*"|'javascript:[^']*'|javascript:[^\s>]+)/gi,
      ''
    );
}

export function renderSanitizedMarkdown(markdown: string): string {
  const raw = marked.parse(markdown, { async: false }) as string;
  return getPurify().sanitize(preStrip(raw));
}
